/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React,{createContext, lazy, Suspense, useEffect,useState} from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import axios from 'axios'
import Home from './pages/Home'
import './normalize.css'
import { ScreenClassProvider, setConfiguration } from 'react-grid-system'
import { FormspreeProvider } from '@formspree/react'
import RouteWrapper from './components/shared/RouteWrapper'
import ScrollToTop from './scrollToTop'

// Each page loads its own chunk on navigation instead of shipping in one bundle
const Faculty = lazy(() => import('./pages/Faculty'))
const Events = lazy(() => import('./pages/Events'))
const Shows = lazy(() => import('./pages/Shows'))
const Guests = lazy(() => import('./pages/Guests'))
const Apply = lazy(() => import('./pages/Apply'))
const Alumni = lazy(() => import('./pages/Alumni'))
const Resources = lazy(() => import('./pages/Resources'))
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'))
import {createClient} from 'contentful'
import { BlogPosts } from './components/Resources/Data'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

setConfiguration({ maxScreenClass: 'xl' })
export const BlogContext=createContext<BlogPosts[]>([]);
export const contentfulClient=createClient({
  space:'2gv8suilbgb4', accessToken:'vq16Pr7DZIfNvpRXdOatHHADLwL_kCXhEacC7h-vbD8'
})

function App() {
  // development only
  // axios.defaults.baseURL = 'http://localhost:5001/podcast-fellows/us-central1';
  axios.defaults.baseURL = 'https://us-central1-fellows-forms.cloudfunctions.net';

  const [blogPosts,setBlogPosts]=useState<BlogPosts[]>([])

useEffect(()=>{
    // include: 1 returns linked assets (thumbnails, author photos) in the same
    // response, so we don't need a follow-up request per post
    contentfulClient.getEntries({ content_type: 'resources', include: 1 })
        .then((response: any)=>{
            const assetUrl: Record<string, string> = {}
            ;(response.includes?.Asset ?? []).forEach((a: any) => {
                const url = a?.fields?.file?.url
                if (typeof url === 'string') {
                    assetUrl[a.sys.id] = url.startsWith('//') ? `https:${url}` : url
                }
            })
            const extractExcerpt = (body: any): string => {
                let text = ''
                for (const node of body?.content ?? []) {
                    if (node.nodeType !== 'paragraph') continue
                    for (const child of node.content ?? []) {
                        if (child.nodeType === 'text') text += child.value
                    }
                    if (text.trim().length > 40) break
                }
                text = text.trim()
                return text.length > 180 ? `${text.slice(0, 177).trimEnd()}…` : text
            }
            const posts: BlogPosts[] = response.items.map((item: any) => ({
                id: item.sys.id,
                title: item.fields.title,
                body: documentToReactComponents(item.fields.body),
                imageURL: item.fields.thumbnail?.sys?.id ?? '',
                imageSrc: assetUrl[item.fields.thumbnail?.sys?.id],
                authorImageSrc: assetUrl[item.fields.authorPicture?.sys?.id],
                excerpt: extractExcerpt(item.fields.body),
                date: item.fields.date,
                author: item.fields.author,
            }))
            setBlogPosts(posts)
        })
        .catch(e=>console.error('error'+e))
},[])


  return (
    <BlogContext.Provider value={blogPosts}>
    <ScreenClassProvider>
      <FormspreeProvider project="1650066375743372547">
        <Router>
          <ScrollToTop />
          <Suspense fallback={null}>
          <Switch>
            <RouteWrapper path="/apply" component={Apply} />
            <RouteWrapper path="/faculty" component={Faculty} />
            <RouteWrapper path="/events" component={Events} />
            <RouteWrapper path="/resources" component={Resources} />
            <RouteWrapper path="/guests" component={Guests} />
            <RouteWrapper path="/alumni" component={Alumni}/>
            <RouteWrapper path="/shows" component={Shows} />
            <RouteWrapper path="/blog/:postId" component={BlogPostPage} />
            <RouteWrapper path="/" component={Home} />
          </Switch>
          </Suspense>
        </Router>
      </FormspreeProvider>
    </ScreenClassProvider>
    </BlogContext.Provider>
  )
}

export default App
